<template>
  <Layout>
    <Sider class="sider">
      <Header class="header">
        <img class="layout-logo" src="../assets/img/bgicon.png" alt=""/>
        <div class="header-title" v-if="orgName">机构名：{{ basicInfo.orgName }}</div>
        <div class="header-title" v-if="teamName">团队名：{{ basicInfo.teamName }}</div>
        <div class="header-title" v-if="roleName">角色名：{{ basicInfo.roleName }}</div>
      </Header>
      <LuMenu :active-name="$route.name" style=" background:rgba(22, 31, 42, 1)" width="auto">
        <LuMenuItem
          v-for="(item, index) in routeslist"
          :key="index"
          :name="item.name"
          :to="item.url"
        >
          <i :class="item.icon"></i>
          {{ item.name }}
        </LuMenuItem>
      </LuMenu>
    </Sider>
    <Layout :style=" { height: '100vh' }">
      <Header class="content-header">
        <div>
          <div class="header-menu-list">
            <div class="header-menu-item" @click="openTodoDialog">
              待办事项
              <span class="header-menu-item-badge">{{ todo.total }}</span>
            </div>

            <div class="header-menu-item" v-if="isHealthManager" @click="showQrCode">我的名片</div>
            <!--<div class="header-menu-item" v-if="link.doctorLink" @click="showLinkDialog">我的链接</div>-->
            <div class="header-menu-item" @click="openBasicInfo">基本信息</div>
            <div class="header-menu-item" @click="showModifyPass">账号设置</div>
            <div class="header-menu-item" @click="handleLogout">退出</div>
            <div class="info-wrapper">
              <img class="avatar" :src="basicInfo.avatar"/>
              <div class="name-wrapper">
                <div class="name">{{basicInfo.userName}}</div>
                <div class="id">ID:{{basicInfo.id}}</div>
              </div>
            </div>
          </div>
        </div>
      </Header>
      <Layout>
        <Content v-if="basicInfoOK" class="content-body">
          <router-view></router-view>
        </Content>
      </Layout>
    </Layout>
    <basicInfo :visible="basicInfo.visible" :editAble="true" @close="handleBasicInfoClose"/>
    <modifyPass :visible="modify.visible" @close="handleModifyPassClose"/>
    <qrCodeDialog :visible="qrCode.visible" :doctorId="qrCode.doctorId" @close="handleQrCodeClose"/>
    <linkDialog :visible="link.visible" :doctorLink="link.doctorLink" @close="handleLinkDialogClose"/>
    <todoDialog :visible="todo.visible" :doctorId="todo.doctorId" @close="handleTODOClose"/>
    <zsfaRecordListDialog @close="zsfaRecordListDialogClose" :visible="zsfaRecordList.visible" :params="zsfaRecordList.params"/>
    <warningRecordListDialog @close="warningRecordListDialogClose" :visible="warningRecordList.visible" :params="warningRecordList.params"/>
    <systemNewsListDialog @close="systemNewsListClose" :visible="systemNewsList.visible" :params="warningRecordList.params"/>
    <systemNewsDetailDialog @close="systemNewsDetailClose" :detail="systemNewsDetail.detail" :visible="systemNewsDetail.visible"/>
    <zsfaProcessDialog @close="zsfaProcessClose" :detail="zsfaProcess.detail" :visible="zsfaProcess.visible"/>
    <warningProcessDialog @close="warningProcessClose" :detail="warningProcess.detail" :visible="warningProcess.visible"/>
    <userBasicInfo :visible="userBasicInfo.visible" pathPre="" @close="userBasicInfoClose" :user="userBasicInfo.user"/>
    <zsfaDetailDailog @close="zsfaDetailClose" :userId="zsfaDetail.userId" :visible="zsfaDetail.visible"/>
    <dietRecordList @close="dietRecordListClose" :userId="dietRecordList.userId" :visible="dietRecordList.visible" :params="dietRecordList.params"/>
    <dietProcessDialog @close="dietProcessClose" :params="dietProcess.params" :visible="dietProcess.visible"/>
    <newsDialog @close="newsDialogClose" :visible="news.visible" :params="news.params"/>
    <newsRecordListDialog @close="newsRecordListDialogClose" :visible="newsRecordList.visible" :params="newsRecordList.params"/>
  </Layout>
</template>

<script>
import { getUserRole, isLogin, logout } from "../utils/login";
import { getMenuList } from "../utils/menu";
import LuMenu from "./common/lu-menu";
import basicInfo from "../components/userInfo/basicInfo.vue";
import modifyPass from "../components/userInfo/modifyPass.vue";
import qrCodeDialog from "./userInfo/qrCodeDialog.vue";
import linkDialog from "./userInfo/linkDialog.vue";
import todoDialog from "./userInfo/todoListDialog.vue";
import systemNewsListDialog from "./system/systemNewsList-dialog.vue";
import systemNewsDetailDialog from "./system/systemNewsDetail-dialog.vue";
import zsfaProcessDialog from "./zsfa/zsfaProcess-dialog.vue";
import warningProcessDialog from "./warning/warningProcess-dialog.vue";
import zsfaRecordListDialog from "./zsfa/zsfaRecordList-dialog.vue";
import dietRecordList from "./diet/dietRecordList-dialog.vue";
import dietProcessDialog from "./diet/dietProcess-dialog.vue";
import warningRecordListDialog from "./warning/warningRecordList-dialog.vue";
import userBasicInfo from "./healthRecords/userBasicInfo.vue";
import zsfaDetailDailog from "./healthRecords/zsfa-dailog.vue";
import newsDialog from "./news/newsDialog.vue";
import newsRecordListDialog from "./news/newsRecordList-dialog.vue";
export default {
  components: {
    LuMenu, // fix 动态menu activeName 不生效 bug
    LuMenuItem: LuMenu.Item,
    basicInfo,
    modifyPass,
    qrCodeDialog,
    linkDialog,
    todoDialog,
    zsfaRecordListDialog,
    warningRecordListDialog,
    systemNewsListDialog,
    systemNewsDetailDialog,
    zsfaProcessDialog,
    userBasicInfo,
    warningProcessDialog,
    zsfaDetailDailog,
    dietRecordList,
    dietProcessDialog,
    newsDialog,
    newsRecordListDialog
  },
  data() {
    return {
      orgName: false,
      teamName: false,
      roleName:false,
      routeslist: [],
      hasBasic: false,
      isHealthManager: false,
      basicInfoOK: false,
      basicInfo: {
        userName: '',
        avatar: '',
        visible: false,
        orgName: "",
        teamName: "",
        roleName:"",
        type: "",
        pid:""
      },
      modify: {
        visible: false,
      },
      qrCode: {
        visible: false,
        doctorId: '',
      },
      link: {
        visible: false,
        doctorLink: '',
      },
      todo: {
        visible: false,
        total: '',
      },
      zsfaRecordList: {
        visible: false,
        params: {}
      },
      warningRecordList: {
        visible: false,
        params: {}
      },
      systemNewsList: {
        visible: false,
        params: {}
      },
      systemNewsDetail: {
        visible: false,
        detail: {},
      },
      zsfaProcess: {
        visible: false,
        detail: {},
      },
      warningProcess: {
        visible: false,
        detail: {},
      },
      userBasicInfo: {
        userId: '',
        visible: false
      },
      zsfaDetail: {
        userId: '',
        visible: false
      },
      dietRecordList: {
        params: {},
        visible: false
      },
      dietProcess: {
        params: '',
        visible: false
      },
      news: {
        visible: false,
        params: {}
      },
      newsRecordList: {
        visible: false,
        params: {}
      },
    };
  },
  async mounted() {
    let that = this;
    if (!isLogin()) {
      await that.$router.push({ path: "/login" });
    } else {
      // 获取用户角色和角色名称
      const userInfo = await getUserRole();
      console.log(18893, userInfo);
      Object.assign(that.user, userInfo);

      that.basicInfo.id = that.user.id;
      that.basicInfo.avatar = that.user.avatar;
      that.basicInfo.orgName = that.user.orgName;
      if(that.user.orgName !==""){that.orgName = true}
      that.basicInfo.teamName = that.user.teamName;
      if(that.user.teamName !==""){that.teamName = true}
      that.basicInfo.userName = that.user.userName;
      that.basicInfo.roleName = that.user.roleName;
      if(that.user.roleName !==""){that.roleName = true}
      that.basicInfo.id = that.user.sysUserId;
      that.basicInfo.pid = that.user.orgId;
      that.basicInfo.type = that.user.type;
      that.qrCode.doctorId = that.user.doctorId;


      that.api.sysRoleMenu(userInfo.roleId).then((response) => {
        if (response.data.code === 0) {
          that.routeslist = response.data.menu;
        } else {
          that.routeslist = getMenuList(userInfo.roleName, that.user.doctorTypeE);
        }
      });

      that.basicInfoOK = true;
      that.queryTodoCount();
      //隐藏名片
      if (userInfo.roleName.includes('咨询')) {
        that.isHealthManager = true;
      } else {
        that.isHealthManager = false;
      }
      if (userInfo.roleName.includes('管理员')||userInfo.roleName.includes('机构')||userInfo.roleName.includes('团队')) {
        that.basicInfo.type = that.user.roleType;
        that.$router.push({ path: "/user" });
      } else {
        console.log("that.user.data.code:"+that.user.code)
        if (that.user.code === 0) {
            that.link.doctorLink = that.user.doctorQrCode
            that.$router.push({ path: "/healthRecords" });
          }else{
            await that.openBasicInfo();
        }
      }
    }
  },
  created() {
    var that = this;
    that.notificationCenter.addOnceNotification('openUserBasicInfo', that.openUserBasicInfo, that);
    that.notificationCenter.addOnceNotification('openZsfaProcess', that.openZsfaProcess, that);
    that.notificationCenter.addOnceNotification('openWarningProcess', that.openWarningProcess, that);
    that.notificationCenter.addOnceNotification('openZsfaRecordListDialog', that.openZsfaRecordListDialog, that);
    that.notificationCenter.addOnceNotification('openDietRecordListDialog', that.openDietRecordListDialog, that);
    that.notificationCenter.addOnceNotification('openWarningRecordListDialog', that.openWarningRecordListDialog, that);
    that.notificationCenter.addOnceNotification('openSystemNewsListDialog', that.openSystemNewsListDialog, that);
    that.notificationCenter.addOnceNotification('openSystemNewsDetail', that.openSystemNewsDetail, that);
    that.notificationCenter.addOnceNotification('openZsfaDetailDailog', that.openZsfaDetailDailog, that);
    that.notificationCenter.addOnceNotification('openDietProcessDialog', that.openDietProcessDialog, that);
    that.notificationCenter.addOnceNotification('openNewsDailog', that.openNewsDailog, that);
    that.notificationCenter.addOnceNotification('openNewsRecordListDialog', that.openNewsRecordListDialog, that);
  },                                             
  methods: {

    initBasicInfo() {
      var that = this;

      that.api.userBaseInfo().then((response) => {
        console.log('333888' + response);
        if (response.data.code === 0) {
          if (!response.data.data) {
            that.openBasicInfo();
          }
          else {
            that.api.doctorLink().then((response) => {
              console.log(333888 + response);
              if (response.data.code == 0) {
                that.link.doctorLink = response.data.data;
              }
            });
            that.$router.push({ path: "/healthRecords" });
          }
        }
        else {
          that.openBasicInfo();
        }
      });
    },
    queryTodoCount() {
      var that = this;
      that.api.todoQuery().then((response) => {
        response = response.data;
        if (response.code == 0) {
          // that.tableparam.total = response.data.totalCount;
          that.todo.total = response.data.count;
        }
      });
    },
    openUserBasicInfo(row) {
      if (this.userBasicInfo.visible) {
        this.showMessage('已打开');
        return ;
      }
      this.userBasicInfo.user = row;
      this.userBasicInfo.visible = true;
    },
    userBasicInfoClose() {
      var that = this;
      that.userBasicInfo.user = null;
      that.userBasicInfo.visible = false;
    },
    openZsfaRecordListDialog(params) {
      if (this.zsfaRecordList.visible) {
        // eslint-disable-next-line no-undef
        this.showMessage('已打开');
        return ;
      }
      this.zsfaRecordList.visible = true;
      this.zsfaRecordList.params = params;
    },
    openWarningRecordListDialog(params) {
      if (this.warningRecordList.visible) {
        // eslint-disable-next-line no-undef
        this.showMessage('已打开');
        return ;
      }
      this.warningRecordList.visible = true;
      this.warningRecordList.params = params;
    },
    openSystemNewsListDialog(params) {
      if (this.systemNewsList.visible) {
        // eslint-disable-next-line no-undef
        this.showMessage('已打开');
        return ;
      }
      this.systemNewsList.visible = true;
      this.systemNewsList.params = params;
    },
    openDietRecordListDialog(params) {
      if (this.dietRecordList.visible) {
        // eslint-disable-next-line no-undef
        this.showMessage('已打开');
        return ;
      }
      this.dietRecordList.visible = true;
      this.dietRecordList.params = params;
    },
    openDietProcessDialog(row) {
      if (this.dietProcess.visible) {
        // eslint-disable-next-line no-undef
        this.showMessage('已打开');
        return ;
      }
      this.dietProcess.visible = true;
      this.dietProcess.params = row;
    },
    openTodoDialog() {
      if (this.todo.visible) {
        // eslint-disable-next-line no-undef
        this.showMessage('已打开');
        return ;
      }
      this.todo.visible = true;
    },
    openZsfaProcess(row) {
      if (this.zsfaProcess.visible) {
        // eslint-disable-next-line no-undef
        this.showMessage('已打开');
        return ;
      }
      this.zsfaProcess.visible = true;
      this.zsfaProcess.detail = row;
    },
    openWarningProcess(row) {
      if (this.warningProcess.visible) {
        // eslint-disable-next-line no-undef
        this.showMessage('已打开');
        return ;
      }
      this.warningProcess.visible = true;
      this.warningProcess.detail = row;
    },
    openSystemNewsDetail(detail) {
      if (this.systemNewsDetail.visible) {
        // eslint-disable-next-line no-undef
        this.showMessage('已打开');
        return ;
      }
      this.systemNewsDetail.detail = detail;
      this.systemNewsDetail.visible = true;
    },
    openZsfaDetailDailog(detail) {
      if (this.zsfaDetail.visible) {
        // eslint-disable-next-line no-undef
        this.showMessage('已打开');
        return ;
      }
      this.zsfaDetail.userId = detail.id;
      this.zsfaDetail.visible = true;
    },
    openNewsDailog(data) {
      if (this.news.visible) {
        // eslint-disable-next-line no-undef
        this.showMessage('已打开');
        return ;
      }
      this.news.params = data;
      this.news.visible = true;
    },
    openNewsRecordListDialog(params) {
      if (this.newsRecordList.visible) {
        // eslint-disable-next-line no-undef
        this.showMessage('已打开');
        return ;
      }
      this.newsRecordList.visible = true;
      this.newsRecordList.params = params;
    },
    zsfaRecordListDialogClose() {
      this.zsfaRecordList.visible = false;
      this.zsfaRecordList.params = {};
    },
    warningRecordListDialogClose() {
      this.warningRecordList.visible = false;
      this.warningRecordList.params = {};
    },
    dietRecordListClose() {
      this.dietRecordList.visible = false;
      this.dietRecordList.params = {};
    },
    dietProcessClose() {
      this.dietProcess.visible = false;
    },
    systemNewsListClose() {
      this.systemNewsList.visible = false;
      this.systemNewsList.params = {};
    },
    systemNewsDetailClose() {
      this.systemNewsDetail.visible = false;
    },
    zsfaProcessClose() {
      this.zsfaProcess.visible = false;
    },
    warningProcessClose() {
      this.warningProcess.visible = false;
    },
    zsfaDetailClose() {
      this.zsfaDetail.visible = false;
    },
    newsDialogClose() {
      this.news.visible = false;
      this.news.params = {};
    },
    newsRecordListDialogClose() {
      this.newsRecordList.visible = false;
      this.newsRecordList.params = {};
    },
    handleLogout() {
      logout();
    },
    showQrCode() {
      this.qrCode.visible = true;
    },
    handleQrCodeClose() {
      this.qrCode.visible = false;
    },
    handleTODOClose() {
      this.todo.visible = false;
    },
    openBasicInfo() {
      this.basicInfo.visible = true;
    },
    handleBasicInfoClose() {
      if (this.basicInfo.visible) {
        this.initBasicInfo();
        this.basicInfo.visible = false;
      }
    },
    showLinkDialog() {
      this.link.visible = true;
    },
    handleLinkDialogClose() {
      this.link = false;
    },
    showModifyPass() {
      this.modify.visible = true;
    },
    handleModifyPassClose() {
      this.modify.visible = false;
    },

    showMessage(msg) {
      this.$message({
        showClose: false,
        message: msg,
        type: "warning",
        center: true,
        customClass: 'zZindex'
      });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped="scoped">
.header {
  display: flex;
  align-items: center;
  position: relative;
  height: 180px;
  display: flex;
  flex-direction: column;
  background: rgba(22, 31, 42, 1);
  padding: 0;
  justify-content: center;
}
.header-menu-list {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

}
.zZindex {
  z-index: 3000 !important;
}
.header-menu-item-badge {
  color: red;
  font-size: 12px;
  font-weight: 500;
  position: absolute;
  right: -12px;
  top: -8px;
}
.header-menu-item {
  font-size: 15px;
  font-weight: bold;
  position: relative;
  margin-right: 20px;
}
.header-title {
  font-size: 13px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: bold;
  color: rgba(255, 255, 255, 0.85);
  line-height: 16px;
  margin-top: 18px;
}
.header-button {
  font-size: 11px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  border: 0;
  margin-right: 40px;
}
.header-button:hover {
  cursor: pointer
}
.info-wrapper {
  display: flex;
  align-items: center;
  .avatar {
    width: 32px;
    height: 32px;
    margin-right: 10px;
  }
  .name-wrapper {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .name {
      font-size: 11px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;

      line-height: unset;
    }
    .id {
      font-size: 11px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;

      line-height: unset;
    }
  }

}
.layout {
  border: 1px solid #d7dde4;
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}
.layout-logo {
  width: 50px;
  height: 50px;
  background: #5b6270;
  border-radius: 50%;
}
.layout-nav {
  width: 420px;
  margin: 0 auto;
  margin-right: 20px;
}

.l-menu-item {
  color: #515a6e;
}
.content-header {
  height: 59px;
  background: #FFFFFF;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.1);
  justify-content: flex-end;
  display: flex;
  align-items: center;
}
.content-body {
  padding: 16px;
}
.sider {
  flex: 0 0 180px !important;
  background: rgba(22, 31, 42, 1);
  width: 180px !important;
  min-width: 150px !important;
  max-width: 180px !important;
}
.role-btn {
  margin-right: 20px;
}
/deep/ .ivu-layout-header {
  line-height: unset;
}
/deep/ .ivu-layout {
  overflow-y: scroll;
}
/deep/ .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
  font-size: 13px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #FFFFFF;
  background: rgba(24, 90, 214, 0.3);
}
/deep/ a.ivu-menu-item {
  font-size: 13px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #FFFFFF;
}
/deep/ .ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
  display: none;
}
/deep/ .ivu-menu-vertical.ivu-menu-light:after {
  display: none;
}
</style>
